/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BoletoResponseViewModel } from "../types/BoletoResponseViewModel.ts";
import { billetOrderFeeResponseViewModelSchema } from "./billetOrderFeeResponseViewModelSchema.ts";
import { billetOrderUrlResponseViewModelSchema } from "./billetOrderUrlResponseViewModelSchema.ts";

export const boletoResponseViewModelSchema = z.object({
  id: z.string().nullish(),
  invoiceId: z.string().nullish(),
  receiptId: z.string().nullish(),
  ourNumber: z.number().int().nullish(),
  expireAt: z.string().datetime().nullish(),
  paidAt: z.string().datetime().nullish(),
  cancelledAt: z.string().datetime().nullish(),
  paidByPix: z.boolean().nullish(),
  fine: z.number().nullish(),
  dailyInterest: z.number().nullish(),
  timelyPaymentDiscount: z.number().nullish(),
  instructions: z.string().nullish(),
  daysToProtest: z.number().int().nullish(),
  daysForAutomaticWriteOff: z.number().int().nullish(),
  ourNumberRaw: z.number().int().nullish(),
  barcode: z.string().nullish(),
  registeredAt: z.string().datetime().nullish(),
  pixQrcode: z.string().nullish(),
  pixTrackingCode: z.string().nullish(),
  pixCopyCode: z.string().nullish(),
  status: z.string().nullish(),
  error: z.string().nullish(),
  errorOccurredAt: z.string().datetime().nullish(),
  creditDate: z.string().datetime().nullish(),
  urls: z.optional(z.lazy(() => billetOrderUrlResponseViewModelSchema)),
  fees: z.array(z.lazy(() => billetOrderFeeResponseViewModelSchema)).nullish(),
}) as unknown as ToZod<BoletoResponseViewModel>;
